// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"addskubanner_bannerWrapper__1KNgD","skuBanner":"addskubanner_skuBanner__xdTyQ","fadein":"addskubanner_fadein__I7i7J","loading":"addskubanner_loading__gXl5w"};